import type {MessageDescriptor} from "@formatjs/intl";

const source_product_name = "Zulip";
const product_name = "CollaboryChat";

function replace_product_name(message: string, source: string, replacement: string): string {
    return message.replaceAll(source, () => replacement);
}

export function translation_message_descriptor(
    descriptor: MessageDescriptor,
    messages: Readonly<Record<string, unknown>>,
): MessageDescriptor {
    const default_message = descriptor.defaultMessage;
    if (typeof default_message !== "string" || !default_message.includes(product_name)) {
        return descriptor;
    }
    if (typeof descriptor.id === "string" && Object.hasOwn(messages, descriptor.id)) {
        return descriptor;
    }

    const source_default_message = replace_product_name(
        default_message,
        product_name,
        source_product_name,
    );
    if (typeof descriptor.id !== "string") {
        return {...descriptor, defaultMessage: source_default_message};
    }

    return {
        ...descriptor,
        id: replace_product_name(descriptor.id, product_name, source_product_name),
        defaultMessage: source_default_message,
    };
}

export function translation_message(
    message: string,
    messages: Readonly<Record<string, unknown>>,
): string {
    if (Object.hasOwn(messages, message)) {
        return message;
    }
    return replace_product_name(message, product_name, source_product_name);
}

export function rebrand_translation(
    message: string,
    original_message: MessageDescriptor["defaultMessage"],
): string {
    return typeof original_message === "string" && original_message.includes(product_name)
        ? replace_product_name(message, source_product_name, product_name)
        : message;
}
